import Fetch from "../script/Fetch";
import servicesProvider from "./ServicesProvider";
import Tavolo from "orser-model/Tavolo";

export default class TavoloService {
    async getAllTavoli(ristoranteId: string) {
        return await servicesProvider.getTavoloDbQueries().selectByRistoranteId(ristoranteId);
    }

    async getTavoloListByRistoranteId(ristoranteId: string) {
        try {
            const response = await Fetch.doFetch(`/ristorante/${ristoranteId}/tavolo`, {
                method: "GET"
            });
            let result = await response.json();
            return result.map((tavolo: any) => Tavolo.fromJson(tavolo));
        } catch (error: any) {
            throw new Error("Errore durante il recupero della lista tavoli da postgress.");
        }
    }
}